import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { CrossSellRemoveLightBoxActions } from '../constants/cross_sell_remove_light_box/cross_sell_remove_light_box_actions';

class CrossSellRemoveLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            expanded: false,
            invalid: false,
            obj: null,
            invalidMessage: '',
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.CROSS_SELL_REMOVE_LIGHTBOX_ACTION) {
            switch (action.type) {
                case CrossSellRemoveLightBoxActions.SHOW:
                    if (!state.visible) {
                        state.visible = true;
                        state.invalid = false;
                        state.invalidMessage = '';
                        state.obj = action.payload;
                        this.__emitChange();
                    }

                    break;

                case CrossSellRemoveLightBoxActions.HIDE:
                    if (state.visible) {
                        state.visible = false;
                        state.invalid = false;
                        state.invalidMessage = '';
                        state.obj = null;
                        this.__emitChange();
                    }

                    break;

                case CrossSellRemoveLightBoxActions.EXPAND:
                    if (!state.expanded) {
                        state.expanded = true;
                        this.__emitChange();
                    }

                    break;

                case CrossSellRemoveLightBoxActions.CROSS_SELL_REMOVE_INVALID_ACTION:
                    if (!state.invalid) {
                        state.invalid = true;
                        state.invalidMessage = action.payload;
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}

const CrossSellRemoveLightBoxStore = new CrossSellRemoveLightBoxStoreClass(Dispatcher);
export { CrossSellRemoveLightBoxStore };
